// doc_path (from doc.metadata_v) is a legacy on-prem-style absolute path like
// "Z:\SYS_FILE_HASH_LIBRARY\a\b\hash.pdf" or "V:\somefolder\file.pdf" - the drive letter says
// which Azure Files share (see office-portal's FILE_SHARE_DRIVES/FILE_ACCT_<drive>/etc. config)
// the file actually lives on. This splits a doc_path into the three pieces the backend's
// /files/download endpoint needs: which share, which directory, and which filename.
export function destructureDocPath(doc_path: string): { drive: string; dir: string; filename: string } {
  const match = doc_path.match(/^([A-Za-z]):[\\/]/);
  const drive = (match?.[1] ?? "Z").toUpperCase(); // no recognizable drive prefix -> assume the default/legacy share
  const withoutDrive = doc_path.slice(match?.[0]?.length ?? 0);
  const lastSlashIndex = withoutDrive.lastIndexOf("\\");
  return {
    drive,
    dir: withoutDrive.substring(0, lastSlashIndex),
    filename: withoutDrive.substring(lastSlashIndex + 1),
  };
}
